<template>
  <page-outline :title="$t('pain008.list_trans_file')">
    <template slot="pageContent">
      <div v-if="isSmartphoneOS" slot="fixed">
        <div style="position: absolute; top: 44px; width: 100%">
          <cm-messages-filter
            class="researchfilter"
            style="position: relative; z-index: 10"
            filterType="list"
            :mode="this.mode"
            @refreshInbox="refreshInbox()"
            @applyFilter="applyFilter($event)"
            propedServiceId="9"
            :countResult="paginationObject.nbResultsTotal.toString()">
          </cm-messages-filter>
        </div>
      </div>

      <div class="listPage" style="overflow: hidden">
        <b-row>
          <b-col md="12">
            <div class="requestsList">
              <div v-if="!isSmartphoneOS">
                <cm-messages-filter
                  class="researchfilter"
                  style="position: relative; z-index: 10"
                  filterType="list"
                  :mode="this.mode"
                  :randomId="randomId"
                  @applyFilter="applyFilter($event)"
                  propedServiceId="9"
                  :countResult="paginationObject.nbResultsTotal.toString()">
                </cm-messages-filter>
              </div>
              <div v-if="isSmartphoneOS" :style="customMobileLayoutStyle"></div>
            </div>

            <br/>

            <b-row class="justify-content-center">
              <b-col sm="12">
                <hr class="w-100"/>
              </b-col>
            </b-row>

            <br/>

            <b-row class="form-group justify-content-start m-0 p-0">
              <b-col md="2" cols="6" class="m-0 p-0 mb-2">
                <div :class="{ 'active-tab': currentTab === 'list', 'inactive-tab': currentTab !== 'list'}"
                  class="mr-2 text-left cursor"
                  size="sm"
                  @click="choseTable('list')">
                  <i class="fa-duotone fa-file"></i>
                  {{ $t('pain008.list_import_file') }}
                </div>
              </b-col>
              <b-col md="2" cols="6" class="m-0 p-0 mb-2">
                <div :class="{ 'active-tab': currentTab === 'data', 'inactive-tab': currentTab !== 'data'}"
                  v-if="canSeeDetails"
                  class="mr-2 text-left cursor"
                  size="sm"
                  @click="choseTable('data')">
                  <i class="fa-duotone fa-file-lines"></i>
                  {{ $t('pain008.data_select_file') }}
                </div>
              </b-col>
              <b-col md="2" class="m-0 p-0 mb-2">
                <div :class="{ 'active-tab': currentTab === 'details', 'inactive-tab': currentTab !== 'details'}"
                  v-if="canSeeDetails"
                  class="mr-2 text-center cursor"
                  size="sm"
                  @click="choseTable('details')">
                  <i class="fa-duotone fa-grid"></i>
                  {{ $t('pain008.detail_select_file') }}
                </div>
              </b-col>
              <b-col sm="2" class="m-0 p-0">
                <div :class="{ 'active-tab': currentTab === 'historique', 'inactive-tab': currentTab !== 'historique'}" class="mr-2 text-left cursor" size="sm"
                  v-if="canSeeHisto"
                  @click="choseTable('historique')">
                  <i class="fa-duotone fa-clock-rotate-left"></i>
                  {{ $t('pain008.history_modi') }}
                </div>
              </b-col>
            </b-row>

            <br>

            <!-- Tableau des fichiers importés-->
            <spinner v-if="activateSpinner"></spinner>
            <div v-else-if="currentTab === 'list'">
              <b-table hover responsive
                v-if="items.length"
                class="mt-3"
                :items="items"
                :fields="fields"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDir"
                @head-clicked="sortTable"
                ref="tablePain008Close"
                :id="'table' + '-' + randomString">

                <template #cell(fileImport)="row">
                  <!-- <div @click="row.item._showDetails ? row.toggleDetails : ''" class="d-flex justify-content-between">
                    <span>
                      {{ row.item.fileImport }} &nbsp;&nbsp;
                    </span>
                    <div v-if="row.item.detailsOK.length > 0 || row.item.detailsKO.length > 0" :class="canSeeDetails ? 'cursor': ''">
                      <i v-if="row.item._showDetails" class="fa-solid fa-caret-up text-primary"></i>
                      <i v-else class="fa-solid fa-caret-down"></i>
                    </div>
                  </div> -->
                  <div v-if="checkStatus(row.item.globalState)" @click="showData(row.item.IdFile)" :class="canSeeDetails ? 'cursor': ''">
                    <div class="text-left" v-if="(row.item.fileImport.length > 20)" @mouseover="showFullFileName(row.index)" @mouseleave="hideFullFileName(row.index)">
                      {{ row.item.fileImport }}
                      <div v-if="isMouseOver[row.index]" style="position:absolute; background-color: #fff;border: 1px solid #ccc; padding: 5px;z-index: 1000;">{{row.item.fileImport}}</div>
                    </div>
                    <div class="text-left" v-else>{{ row.item.fileImport }}</div>
                  </div>
                  <div v-else>
                    <div class="text-left" v-if="(row.item.fileImport.length > 20)" @mouseover="showFullFileName" @mouseleave="hideFullFileName">
                      {{ row.item.fileImport }}
                      <div v-if="isMouseOver[row.index]" style ="position:absolute; background-color: #fff;border: 1px solid #ccc; padding: 5px;z-index: 1000;">{{row.item.fileImport}}</div>
                    </div>
                    <div class="text-left" v-else>{{ row.item.fileImport }}</div>
                  </div>
                </template>
                <template #cell(dateImport)="row_d">
                  <div v-if="checkStatus(row_d.item.globalState)" @click="showData(row_d.item.IdFile)" :class="canSeeDetails ? 'cursor': ''">
                    {{ convertTime(row_d.item.dateImport) }}
                  </div>
                  <div v-else>
                    {{ convertTime(row_d.item.dateImport) }}
                  </div>
                </template>
                <template #cell(nbTotalElem)="row_nbe">
                  <div @click="showData(row_nbe.item.idFile)" :class="canSeeDetails ? 'cursor': ''">
                    {{ row_nbe.item.nbTotalElem }}
                  </div>
                </template>
                <template #cell(total)="row_tot">
                  <div v-if="checkStatus(row_tot.item.globalState)" @click="showData(row_tot.item.IdFile)" :class="canSeeDetails ? 'cursor': ''">
                    {{ row_tot.item.total }}
                  </div>
                  <div v-else>
                    {{ row_tot.item.total }}
                  </div>
                </template>
                <template #cell(error)="row_error">
                  <div v-if="checkStatus(row_error.item.globalState)" @click="showData(row_error.item.IdFile)" :class="canSeeDetails ? 'cursor': ''">
                    {{ row_error.item.error }}
                  </div>
                  <div v-else>
                    {{ row_error.item.error }}
                  </div>
                </template>
                <template #cell(validated)="row_validated">
                  <div v-if="checkStatus(row_validated.item.globalState)" @click="showData(row_validated.item.IdFile)" :class="canSeeDetails ? 'cursor': ''">
                    {{ row_validated.item.validated }}
                  </div>
                  <div v-else>
                    {{ row_validated.item.validated }}
                  </div>
                </template>
                <template #cell(process)="row_process">
                  <div v-if="checkStatus(row_process.item.globalState)" @click="showData(row_process.item.IdFile)" :class="canSeeDetails ? 'cursor': ''">
                    {{ row_process.item.process }}
                  </div>
                  <div v-else>
                    {{ row_process.item.process }}
                  </div>
                </template>
                <template #cell(verif)="row_verif">
                  <div v-if="checkStatus(row_verif.item.globalState)" @click="showData(row_verif.item.IdFile)" :class="canSeeDetails ? 'cursor': ''">
                    {{ row_verif.item.verif }}
                  </div>
                  <div v-else>
                    {{ row_verif.item.verif }}
                  </div>
                </template>
                <template #cell(refus)="row_refus">
                  <div v-if="checkStatus(row_refus.item.globalState)" @click="showData(row_refus.item.IdFile)" :class="canSeeDetails ? 'cursor': ''">
                    {{ row_refus.item.refus }}
                  </div>
                  <div v-else>
                    {{ row_refus.item.refus }}
                  </div>
                </template>
                <template #cell(globalState)="row_state">
                  <div v-if="row_state.item.globalState === $t('pain008.file_refused')" class="text-danger cursor">
                    {{ row_state.item.globalState }}
                  </div>
                  <div v-else-if="row_state.item.globalState === $t('pain008.processed_pending')" @click="showData(row_state.item.IdFile)" class="text-muted cursor">
                    {{ row_state.item.globalState }}
                  </div>
                  <div v-else-if="checkStatus(row_state.item.globalState)" @click="showData(row_state.item.IdFile)" :class="canSeeDetails ? 'cursor': ''">
                    {{ row_state.item.globalState }}
                  </div>
                  <div v-else>
                    {{ row_state.item.globalState }}
                  </div>
                </template>
                <template #cell(FolderClose)="row_close">
                  <b-row v-if="row_close.item.FolderClose !== 'Cadenas'">
                    <b-col :class="canSeeDetails ? 'cursor': ''">
                      <div><u>{{ row_close.item.FolderClose }}</u></div>
                    </b-col>
                  </b-row>
                  <b-row v-else>
                    <span class="cursor mx-auto"><i class="fa-duotone fa-lock text-muted text-center"></i></span>
                  </b-row>
                </template>

                <template #row-details="details_row">
                  <b-card class="bg-white border-0 shadow-none p-0 m-0">
                    <b-row v-for="x in details_row.item.detailsOK" :key="x"
                      class="my-1 mx-5 justify-content-center">
                      <b-col md="2" class="text-left">
                        <span class="text-success font-weight-bold">
                          {{ $t('pain008.valid_elements_reissued') }}
                        </span>
                      </b-col>
                      <b-col md="3" class="text-left">
                        {{ x.namefile }}
                      </b-col>
                      <b-col md="2" class="text-left">
                        {{ x.dateimport }}
                      </b-col>
                      <b-col md="1" class="text-left">
                        <i class="fa-light fa-arrow-right"></i>
                      </b-col>
                      <b-col md="1" class="text-left">
                        <span v-if="x.nblignes <= 1"> {{ x.nblignes }} {{ $t('pain008.line') }} </span>
                        <span v-else> {{ x.nblignes }} {{ $t('pain008.lines') }} </span>
                      </b-col>
                    </b-row>
                    <b-row v-for="x in details_row.item.detailsKO" :key="x"
                      class="my-1 mx-5 justify-content-center">
                      <b-col md="2" class="text-left">
                        <span class="text-danger font-weight-bold pt-2">
                          {{ $t('pain008.rejected_elements_reissued') }}
                        </span>
                      </b-col>
                      <b-col md="3" class="text-left">
                        {{ x.namefile }}
                      </b-col>
                      <b-col md="2" class="text-left">
                        {{ x.dateimport }}
                      </b-col>
                      <b-col md="1" class="text-left">
                        <i class="fa-light fa-arrow-right"></i>
                      </b-col>
                      <b-col md="1" class="text-left">
                        <span v-if="x.nblignes <= 1"> {{ x.nblignes }} {{ $t('pain008.line') }} </span>
                        <span v-else> {{ x.nblignes }} {{ $t('pain008.lines') }} </span>
                      </b-col>
                    </b-row>
                  </b-card>
                </template>
              </b-table>

              <div v-else class="d-flex justify-content-center">
                <span class="noResult">
                  {{ $t('common.no_result') }}
                </span>
              </div>

              <b-row class="justify-content-end mt-5" v-if="items.length">
                <b-col lg="2" offset="10" class="mt-3">
                  <b-button variant="primary"
                    @click="extractCSV_items()">
                    <i class="fa-solid fa-arrow-up-from-bracket"></i>
                    {{ $t('pain008.extract_list') }}
                  </b-button>
                </b-col>
              </b-row>

              <b-row class="mt-5">
                <b-col>
                  <cm-pagination
                    :maxResultsByPage="paginationObject.maxResults"
                    :firstIndex="paginationObject.firstIndex"
                    :nbResultsTotal="paginationObject.nbResultsTotal"
                    :refreshEvent="paginationObject.refresh">
                  </cm-pagination>
                </b-col>
              </b-row>

            </div>

            <!-- Tableau données du fichier sélectionné -->
            <div v-else-if="currentTab === 'data'">
              <b-row>
                <b-col lg="2" offset="8" class="mt-3">
                  <b-button @click="resendExpired()" class="btn">
                    <i class="fa-solid fa-refresh" style="margin-right:5px"></i>
                    {{ $t('pain008.refresh_expired') }}
                  </b-button>
                </b-col>
                <b-col lg="2" class="mt-3">
                  <b-button @click="extractCSV_itemsData()" class="btn">
                    <i class="fa-solid fa-arrow-up-from-bracket"></i>
                    {{ $t('pain008.extract_list') }}
                  </b-button>
                </b-col>
              </b-row>
              <br/>

              <b-tabs active-nav-item-class="active-blue font-weight-bold" v-model="tabType">
                <!--Table PM-->
                <b-tab :title="$t('pain008.legal_person')" :active="tabType === 0">
                  <b-row class="my-3 justify-content-around" v-if="this.items[this.currentIndexList]">
                    <b-col cols="12" class="mt-3 font-weight-bold">
                      <span style="color: #6b6aea">
                        {{ $t('pain008.imported_file') }}
                      </span>
                      <span>
                        {{ this.items[this.currentIndexList].fileImport }}
                        <!--<div>
                          {{this.items[currentIndexList].fileImport.substr(0,27)}}
                        </div>-->
                      </span>
                    </b-col>
                  </b-row>
                  <b-row class="my-3 justify-content-around" v-if="this.items[this.currentIndexList]">
                    <b-col cols="1" class="mt-3 font-weight-bold">
                      <span>
                        {{ $t('pain008.total_2') }}
                      </span>
                      <span>
                        {{ nbTotalRequest }}
                      </span>
                    </b-col>
                    <b-col cols="2" class="mt-3 font-weight-bold">
                      <span style="color: #11b1fd">
                        {{ $t('pain008.being_processed') }}
                      </span>
                      <span style="color: #939393">
                        : {{ nbBeingProcessedRequest }}
                      </span>
                    </b-col>
                    <b-col cols="1" class="mt-3 font-weight-bold">
                      <span style="color: orange">
                        {{ $t('pain008.to_verify') }}
                      </span>
                      <span style="color: #939393">
                        : {{ nbToVerifyRequest }}
                      </span>
                    </b-col>
                    <b-col cols="1" class="mt-3 font-weight-bold">
                      <span style="color:#47d89c">
                        {{ $t('pain008.validated') }}
                      </span>
                      <span style="color: #939393">
                        : {{ nbValidatedRequest }}
                      </span>
                    </b-col>
                    <b-col cols="1" class="mt-3 font-weight-bold">
                      <span style="color:#f54336">
                        {{ $t('pain008.refused') }}
                      </span>
                      <span style="color: #939393">
                        : {{ nbRefusedRequest }}
                      </span>
                    </b-col>
                    <b-col cols="1" class="mt-3 font-weight-bold">
                      <span style="color: #f54336">
                        {{ $t('pain008.in_error') }}
                      </span>
                      <span style="color: #939393">
                        : {{ nbErrorRequest }}
                      </span>
                    </b-col>
                    <b-col cols="1" class="mt-3 font-weight-bold">
                      <span style="color:#888888">
                        {{ $t('pain008.ignored') }}
                      </span>
                      <span style="color: #939393">
                        : {{ nbIgnoredRequest }}
                      </span>
                    </b-col>
                    <b-col cols="1" class="mt-3 font-weight-bold">
                      <span style="color:#47d89c">
                        {{ $t('pain008.paid') }}
                      </span>
                      <span style="color: #939393">
                        : {{ nbPaidRequest }}
                      </span>
                    </b-col>
                    <!--<b-col>
                      <div class="requestsList">
                        <div v-if="!isSmartphoneOS">
                          <cm-messages-filter-1
                          class="researchfilter"
                          style="position: relative; z-index: 10"
                          filterType="list"
                          :mode="this.mode"
                          :randomId="randomId"
                          @applyFilter="applyFilterData($event)"
                          propedServiceId="9">
                        </cm-messages-filter-1>
                        </div>
                        <div v-if="isSmartphoneOS" :style="customMobileLayoutStyle"></div>
                      </div>
                    </b-col>-->
                  </b-row>

                  <div v-if="itemsDataPM.length">
                    <b-table hover responsive sticky-header
                      :items="itemsDataPM"
                      :fields="fieldsDataPM"
                      :sort-by.sync="sortByData"
                      :sort-desc.sync="sortDirData"
                      @head-clicked="sortTableData"
                      ref="tablePain008DataClose"
                      :id="'table-data' + '-' + randomString">

                      <template #head(validAll)>
                        <!--<template v-if="itemsDataPM.filter(elem => elem.stateVerif !== $t('pain008.positive_response') && elem.StatusValidation === '1').length">
                          <b-form-checkbox v-model="allcheckedValid" @change="selectAll('ValideAll')">
                            <span style="color: var(--actionTextColorBlack)">
                              {{ $t('pain008.validate_all') }}
                            </span>
                          </b-form-checkbox>
                        </template>
                        <template v-else><span></span></template>-->
                      </template>

                      <template #head(rejectAll)>
                        <!--<template v-if="itemsDataPM.filter(elem => elem.stateVerif !== $t('pain008.positive_response') && elem.StatusValidation === '1').length">
                          <b-form-checkbox v-model="allcheckedReject" @change="selectAll('rejectAll')">
                            <span style="color: var(--actionTextColorBlack)">
                              {{ $t('pain008.decline_all') }}
                            </span>
                          </b-form-checkbox>
                        </template>
                        <template v-else><span></span></template>-->
                      </template>

                      <template #cell(name)="row">
                        <div :class="canSeeDetails ? 'cursor': ''"
                          @click="showDetails(row.index)"
                          v-if="(row.item.name.length > 20)"
                          @mouseover="showFullFileName(row.item.index)"
                          @mouseleave="hideFullFileName(row.item.index)">
                          {{ row.item.name }}
                          <div v-if="isMouseOver[row.item.index]" style="position:absolute; background-color: #fff;border: 1px solid #ccc; padding: 5px;z-index: 1000;">
                            {{ row.item.name }}
                          </div>
                        </div>
                        <div :class="canSeeDetails ? 'cursor': ''"
                          @click="showDetails(row.index)" v-else>
                          {{ row.item.name }}
                        </div>
                      </template>
                      <template #cell(iban)="row">
                        <div :class="canSeeDetails ? 'cursor': ''"
                          @click="showDetails(row.index)">
                          {{ row.item.iban }}
                        </div>
                      </template>
                      <template #cell(siren)="row">
                        <div :class="canSeeDetails ? 'cursor': ''"
                          @click="showDetails(row.index)">
                          {{ row.item.siren }}
                        </div>
                      </template>
                      <template #cell(verifIban)="row">
                        <div v-if="row.item.verifIban === 'Faux'"
                          class="cursor text-danger"
                          @click="showDetails(row.index)">
                          {{ row.item.verifIban }}
                        </div>
                        <div v-else :class="canSeeDetails ? 'cursor': ''"
                          v-html="row.item.verifIban"
                          @click="showDetails(row.index)">
                        </div>
                      </template>
                      <template #cell(verifSiren)="row">
                        <div v-if="row.item.verifSiren === 'Faux'"
                          class="cursor text-danger"
                          @click="showDetails(row.index)">
                          {{ row.item.verifSiren }}
                        </div>
                        <div v-else :class="canSeeDetails ? 'cursor': ''"
                          v-html="row.item.verifSiren"
                          @click="showDetails(row.index)">
                        </div>
                      </template>
                      <template #cell(score)="row">
                        <span :class="canSeeDetails ? 'cursor': ''"
                          @click="showDetails(row.index)">
                          {{ row.item.score }}
                        </span>
                      </template>
                      <template #cell(stateVerif)="row">
                        <div :class="canSeeDetails ? 'cursor': ''"
                          @click="showDetails(row.index)">
                          {{ verifStatus(row.item.stateVerif) }}
                        </div>
                      </template>
                      <template #cell(validAll)="row">
                        <template v-if="canDoDecision && row.item.StatusValidation === '1'">
                          <b-form-checkbox v-model="row.item.validAll" @change="decideLine(row, 1)">
                            <u style="color: #11b1fd; font-weight: 400">
                              {{ $t('pain008.validate') }}
                            </u>
                          </b-form-checkbox>
                        </template>
                        <template v-else-if="row.item.StatusValidation === '2'">
                          <div :class="canSeeDetails ? 'cursor': ''"
                            @click="showDetails(row.index)">
                            {{ $t('pain008.validated') }}
                          </div>
                        </template>
                        <template v-else>
                          <div :class="canSeeDetails ? 'cursor': ''"
                            @click="showDetails(row.index)">
                          </div>
                        </template>
                      </template>
                      <template #cell(rejectAll)="row">
                        <template v-if="canDoDecision && row.item.StatusValidation === '1'">
                          <b-form-checkbox v-model="row.item.rejectAll" @change="decideLine(row, 0)">
                            <u style="color: #000000; font-weight: 400">
                              {{ $t('pain008.refus') }}
                            </u>
                          </b-form-checkbox>
                        </template>
                        <template v-else-if="row.item.StatusValidation === '3'">
                          <div :class="canSeeDetails ? 'cursor': ''"
                            @click="showDetails(row.index)">
                            {{ $t('pain008.denied') }}
                          </div>
                        </template>
                        <template v-else>
                          <div :class="canSeeDetails ? 'cursor': ''"
                            @click="showDetails(row.index)">
                          </div>
                        </template>
                      </template>
                      <template #cell(paid)="row">
                        <template v-if="row.item.StatusValidation === '6'">
                          <div :class="canSeeDetails ? 'cursor': ''"
                            @click="showDetails(row.index)">
                            {{ $t('pain008.paid') }}
                          </div>
                        </template>
                      </template>
                    </b-table>
                    <b-row class="mt-5">
                      <b-col>
                        <b-col cols="12">
                          <cm-pagination
                            :maxResultsByPage="paginationObjectData.maxResults"
                            :firstIndex="paginationObjectData.firstIndex"
                            :nbResultsTotal="paginationObjectData.nbResultsTotal"
                            :refreshEvent="paginationObjectData.refresh">
                          </cm-pagination>
                        </b-col>
                      </b-col>
                    </b-row>
                  </div>
                  <div v-else class="d-flex justify-content-center">
                    <span class="noResult">
                      {{ $t('pain008.no_PM') }}
                    </span>
                  </div>

                  <!--<br />

                  <b-progress height="20px" :min="min" :max="max" class="mt-3 mb-5">
                    <b-progress-bar :value="value" show-progress
                      :label="`${((value * 100) / max).toFixed(0)}%`">
                    </b-progress-bar>
                  </b-progress>-->
                </b-tab>

                <!--Table PP-->

                <b-tab :title="$t('pain008.physical_person')" :active="tabType === 1">
                  <b-row class="my-3 justify-content-around" v-if="this.items[this.currentIndexList]">
                    <b-col cols="12" class="mt-3 font-weight-bold">
                      <span style="color: #6b6aea">
                        {{ $t('pain008.imported_file') }}
                      </span>
                      <span>
                        {{ this.items[this.currentIndexList].fileImport }}
                      </span>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="1" class="mt-3 font-weight-bold">
                      <span>
                        {{ $t('pain008.total_2') }}
                      </span>
                      <span>
                        {{ nbTotalRequest }}
                      </span>
                    </b-col>
                    <b-col cols="2" class="mt-3 font-weight-bold">
                      <span style="color: #11b1fd">
                        {{ $t('pain008.being_processed') }}
                      </span>
                      <span style="color: #939393">
                        : {{ nbBeingProcessedRequest }}
                      </span>
                    </b-col>
                    <b-col cols="1" class="mt-3 font-weight-bold">
                      <span style="color: orange">
                        {{ $t('pain008.to_verify') }}
                      </span>
                      <span style="color: #939393">
                        : {{ nbToVerifyRequest }}
                      </span>
                    </b-col>
                    <b-col cols="1" class="mt-3 font-weight-bold">
                      <span style="color:#47d89c">
                        {{ $t('pain008.validated') }}
                      </span>
                      <span style="color: #939393">
                        : {{ nbValidatedRequest }}
                      </span>
                    </b-col>
                    <b-col cols="1" class="mt-3 font-weight-bold">
                      <span style="color:#f54336">
                        {{ $t('pain008.refused') }}
                      </span>
                      <span style="color: #939393">
                        : {{ nbRefusedRequest }}
                      </span>
                    </b-col>
                    <b-col cols="1" class="mt-3 font-weight-bold">
                      <span style="color: #f54336">
                        {{ $t('pain008.in_error') }}
                      </span>
                      <span style="color: #939393">
                        : {{ nbErrorRequest }}
                      </span>
                    </b-col>
                    <b-col cols="1" class="mt-3 font-weight-bold">
                      <span style="color:#888888">
                        {{ $t('pain008.ignored') }}
                      </span>
                      <span style="color: #939393">
                        : {{ nbIgnoredRequest }}
                      </span>
                    </b-col>
                    <b-col cols="1" class="mt-3 font-weight-bold">
                      <span style="color:#47d89c">
                        {{ $t('pain008.paid') }}
                      </span>
                      <span style="color: #939393">
                        : {{ nbPaidRequest }}
                      </span>
                    </b-col>
                    <!--<b-col>
                      <div class="requestsList">
                        <div v-if="!isSmartphoneOS">
                          <cm-messages-filter-1
                            class="researchfilter"
                            style="position: relative; z-index: 10"
                            filterType="list"
                            :mode="this.mode"
                            :randomId="randomId"
                            @applyFilter="applyFilterData($event)"
                            propedServiceId="9">
                          </cm-messages-filter-1>
                        </div>
                        <div v-if="isSmartphoneOS" :style="customMobileLayoutStyle"></div>
                      </div>
                    </b-col>-->
                  </b-row>
                  <div v-if="itemsDataPP.length">
                    <b-table hover responsive sticky-header
                      :items="itemsDataPP"
                      :fields="fieldsDataPP"
                      :sort-by.sync="sortByData"
                      :sort-desc.sync="sortDirData"
                      @head-clicked="sortTableData"
                      ref="tablePain008DataClose"
                      :id="'table-data' + '-' + randomString">

                      <template #head(validAll)>
                        <!--<template v-if="itemsDataPP.filter(elem => elem.stateVerif !== $t('pain008.positive_response') && elem.StatusValidation === '1').length">
                          <b-form-checkbox v-model="allcheckedValid" @change="selectAll('ValideAll')">
                            <span style="color: var(--actionTextColorBlack)">
                              {{ $t('pain008.validate_all') }}
                            </span>
                          </b-form-checkbox>
                        </template>
                        <template v-else><span></span></template>-->
                      </template>

                      <template #head(rejectAll)>
                        <!--<template v-if="itemsDataPP.filter(elem => elem.stateVerif !== $t('pain008.positive_response') && elem.StatusValidation === '1').length">
                          <b-form-checkbox v-model="allcheckedReject" @change="selectAll('rejectAll')">
                            <span style="color: var(--actionTextColorBlack)">
                              {{ $t('pain008.decline_all') }}
                            </span>
                          </b-form-checkbox>
                        </template>
                        <template v-else><span></span></template>-->
                      </template>

                      <template #cell(name)="row">
                        <div :class="row.item.StatusValidation !== '4' ? 'cursor' : ''"
                          @click="showDetails(row.index)" v-if="(row.item.name.length > 20)"
                          @mouseover="showFullFileName(row.item.index)"
                          @mouseleave="hideFullFileName(row.item.index)">
                          {{ row.item.name }}
                          <div v-if="isMouseOver[row.item.index]" style="position:absolute; background-color: #fff;border: 1px solid #ccc; padding: 5px;z-index: 1000;">
                            {{ row.item.name }}
                          </div>
                        </div>
                        <div :class="canSeeDetails ? 'cursor': ''"
                          @click="showDetails(row.index)" v-else>
                          {{ row.item.name }}
                        </div>
                      </template>
                      <template #cell(iban)="row">
                        <div :class="canSeeDetails ? 'cursor': ''"
                          @click="showDetails(row.index)">
                          {{ row.item.iban }}
                        </div>
                      </template>
                      <template #cell(siren)="row">
                        <div :class="canSeeDetails ? 'cursor': ''"
                          @click="showDetails(row.index)">
                          {{ row.item.siren }}
                        </div>
                      </template>
                      <template #cell(verifIban)="row">
                        <div v-if="row.item.verifIban === 'Faux'"
                          class="cursor text-danger"
                          @click="showDetails(row.index)">
                          {{ row.item.verifIban }}
                        </div>
                        <div v-else :class="canSeeDetails ? 'cursor': ''"
                          v-html="row.item.verifIban"
                          @click="showDetails(row.index)">
                        </div>
                      </template>
                      <template #cell(verifSiren)="row">
                        <div v-if="row.item.verifSiren === 'Faux'"
                          class="cursor text-danger"
                          @click="showDetails(row.index)">
                          {{ row.item.verifSiren }}
                        </div>
                        <div v-else :class="canSeeDetails ? 'cursor': ''"
                          v-html="row.item.verifSiren"
                          @click="showDetails(row.index)">
                        </div>
                      </template>
                      <template #cell(score)="row">
                        <span :class="canSeeDetails ? 'cursor': ''"
                          @click="showDetails(row.index)">
                          {{ row.item.score }}
                        </span>
                      </template>
                      <template #cell(stateVerif)="row">
                        <div :class="canSeeDetails ? 'cursor': ''"
                          @click="showDetails(row.index)">
                          {{ verifStatus(row.item.stateVerif) }}
                        </div>
                      </template>
                      <template #cell(validAll)="row">
                        <template v-if="canDoDecision && row.item.StatusValidation === '1'">
                          <b-form-checkbox v-model="row.item.validAll" @change="decideLine(row, 1)">
                            <u style="color: #11b1fd; font-weight: 400">
                              {{ $t('pain008.validate') }}
                            </u>
                          </b-form-checkbox>
                        </template>
                        <template v-else-if="row.item.StatusValidation === '2'">
                          <div :class="canSeeDetails ? 'cursor': ''"
                            @click="showDetails(row.index)">
                            {{ $t('pain008.validated') }}
                          </div>
                        </template>
                        <template v-else>
                          <div :class="canSeeDetails ? 'cursor': ''"
                            @click="showDetails(row.index)">
                          </div>
                        </template>
                      </template>
                      <template #cell(rejectAll)="row">
                        <template v-if="canDoDecision && row.item.StatusValidation === '1'">
                          <b-form-checkbox v-model="row.item.rejectAll" @change="decideLine(row, 0)">
                            <u style="color: #000000; font-weight: 400">
                              {{ $t('pain008.refus') }}
                            </u>
                          </b-form-checkbox>
                        </template>
                        <template v-else-if="row.item.StatusValidation === '3'">
                          <div :class="canSeeDetails ? 'cursor': ''"
                            @click="showDetails(row.index)">
                            {{ $t('pain008.denied') }}
                          </div>
                        </template>
                        <template v-else>
                          <div :class="canSeeDetails ? 'cursor': ''"
                            @click="showDetails(row.index)">
                          </div>
                        </template>
                      </template>
                      <template #cell(paid)="row">
                        <template v-if="row.item.StatusValidation === '6'">
                          <div :class="canSeeDetails ? 'cursor': ''"
                            @click="showDetails(row.index)">
                            {{ $t('pain008.paid') }}
                          </div>
                        </template>
                      </template>
                    </b-table>

                    <b-row class="mt-5">
                      <b-col>
                        <b-col cols="12">
                          <cm-pagination
                            :maxResultsByPage="paginationObjectData.maxResults"
                            :firstIndex="paginationObjectData.firstIndex"
                            :nbResultsTotal="paginationObjectData.nbResultsTotal"
                            :refreshEvent="paginationObjectData.refresh">
                          </cm-pagination>
                        </b-col>
                      </b-col>
                    </b-row>
                  </div>
                  <div v-else class="d-flex justify-content-center">
                    <span class="noResult">
                      {{ $t('pain008.no_PP') }}
                    </span>
                  </div>
                  <!--<br />
                  <b-progress height="20px" :min="min" :max="max" class="mt-3 mb-5">
                    <b-progress-bar :value="value"
                      :label="`${((value * 100) / max).toFixed(0)}%`">
                    </b-progress-bar>
                  </b-progress>-->
                </b-tab>
              </b-tabs>

              <b-row class="justify-content-end mt-3" v-if="canDoDecision && itemsData.length">
                <template v-if="itemsData.filter(elem => elem.stateVerif !== '10' && elem.StatusValidation === '1').length">
                  <b-col lg="2" cols="4" class="mt-3">
                    <b-button @click="effacer()" class="btn">
                      {{ $t('pain008.clear_label') }}
                    </b-button>
                  </b-col>
                  <b-col lg="2" cols="4" class="mt-3">
                    <b-button @click="enregistrer()" variant="primary">
                      {{ $t('pain008.sve') }}
                    </b-button>
                  </b-col>
                </template>
              </b-row>
            </div>

            <!-- Tableau détails du fichier sélectionné -->
            <div v-else-if="currentTab === 'details'">
              <b-row class="mb-3 justify-content-between">
                <b-col lg="2" cols="4" class="mb-2" v-if="currentIndexData > 0">
                  <b-button @click="navDetails(-1)" class="btn">
                    <i class="fa-solid fa-chevrons-left"></i>
                    {{ $t('pain008.previous') }}
                  </b-button>
                </b-col>
                <b-col lg="2" cols="4" class="mb-2" v-if="currentIndexData === 0 && currentIndexData < itemsData.length - 1" offset="10">
                  <b-button @click="navDetails(1)" class="btn">
                    {{ $t('pain008.next') }}
                    <i class="fa-solid fa-chevrons-right"></i>
                  </b-button>
                </b-col>
                <b-col lg="2" cols="4" class="mb-2" v-else-if="itemsData.length > 1 && currentIndexData < itemsData.length - 1" offset="8">
                  <b-button @click="navDetails(1)" class="btn">
                    {{ $t('pain008.next') }}
                    <i class="fa-solid fa-chevrons-right"></i>
                  </b-button>
                </b-col>
              </b-row>

              <b-row class="text-center">
                <b-col class="bandeau0 text-dark" style="background-color: #f1f1f1">
                  <b>{{ $t('pain008.global_response') }}</b>
                </b-col>
                <b-col v-if="itemsData[currentIndexData].stateVerif === '10'"
                  class="bandeau2" style="background-color: #47d89c">
                  <b>{{ verifStatus(itemsData[currentIndexData].stateVerif) }}</b>
                </b-col>
                <b-col v-else-if="this.itemsData[currentIndexData].stateVerif === '1' || this.itemsData[currentIndexData].stateVerif === '2'"
                  class="bandeau2 text-dark" style="background-color: #FFCC86">
                  <b>{{ verifStatus(itemsData[currentIndexData].stateVerif) }}</b>
                </b-col>
                <b-col v-else-if="this.itemsData[currentIndexData].stateVerif === '99'"
                  class="bandeau2" style="background-color: #888888">
                  <b>{{ verifStatus(itemsData[currentIndexData].stateVerif) }}</b>
                </b-col>
                <b-col v-else class="bandeau2">
                  <b>{{ verifStatus(itemsData[currentIndexData].stateVerif) }}</b>
                </b-col>
              </b-row>
              <b-row class="text-center mb-4">
                <b-col class="bandeau0 text-dark" style="background-color: #f1f1f1">
                  <b>{{ $t('pain008.remittance_status') }}</b>
                </b-col>
                <b-col v-if="this.itemsData[currentIndexData].StatusValidation === '0'"
                  class="bandeau2 text-dark" style="background-color: #FFCC86">
                  <b>-</b>
                </b-col>
                <b-col v-else-if="this.itemsData[currentIndexData].StatusValidation === '1'"
                  class="bandeau2 text-dark" style="background-color: #FFCC86">
                  <b>{{ $t('pain008.waiting_decision_2') }}</b>
                </b-col>
                <b-col v-else-if="itemsData[currentIndexData].StatusValidation === '2'"
                  class="bandeau2" style="background-color: #47d89c">
                  <b>{{ $t('pain008.validated') }}</b>
                </b-col>
                <b-col v-else-if="this.itemsData[currentIndexData].StatusValidation === '3'"
                  class="bandeau2">
                  <b>{{ $t('pain008.denied') }}</b>
                </b-col>
                <b-col v-else-if="this.itemsData[currentIndexData].StatusValidation === '4'"
                  class="bandeau2">
                  <b>{{ $t('pain008.error') }}</b>
                </b-col>
                <b-col v-else-if="this.itemsData[currentIndexData].StatusValidation === '5'"
                  class="bandeau2" style="background-color: #888888">
                  <b>{{ $t('pain008.ignored') }}</b>
                </b-col>
                <b-col v-else-if="this.itemsData[currentIndexData].StatusValidation === '6'"
                  class="bandeau2" style="background-color: #47d89c">
                  <b>{{ $t('pain008.paid') }}</b>
                </b-col>
              </b-row>

              <div class="title-label-blue" style="width: 350px">
                {{ $t('pain008.check_bank_details') }}
              </div>
              <div style="overflow: visible; height: 290px">
                <b-table hover fixed
                  v-if="itemsData.length"
                  :items="itemsDetails"
                  :fields="fieldsDetails"
                  :sort-by="sortField"
                  ref="tablePain008DetailsClose"
                  :id="'table-details' + '-' + randomString">
                  <template #cell(field)="row">
                    <span>
                      {{ $t('pain008.fields.' + row.item.field) }}
                    </span>
                  </template>
                  <template #cell(value)="row">
                    <span v-if="row.item.field === 'Type'">
                      {{ $t('pain008.' + row.item.value) }}
                    </span>
                    <span v-else>
                      {{ row.item.value }}
                    </span>
                  </template>
                  <template #cell(details)="row">
                    <span>
                      {{ verifAll(row.item.details, row.item.field) }}
                    </span>
                  </template>

                  <!--<template #cell(value)="row">
                    <div :class="canSeeDetails ? 'cursor': ''" v-if="(row.item.value.length > 27)" @mouseover = "showFullFileName(row.index)" @mouseleave ="hideFullFileName(row.index)">
                      {{ row.item.value.substr(0,27)+ '... ' }}
                      <div v-if="isMouseOver[row.index]" style ="position:absolute; background-color: #fff;border: 1px solid #ccc; padding: 5px;z-index: 1000;">
                        {{ row.item.value }}
                      </div>
                    </div>
                    <div :class="canSeeDetails ? 'cursor': ''" v-else>{{ row.item.value }}</div>
                  </template>-->

                  <template #cell(result)="row">
                    <span v-html="row.item.result"></span>
                  </template>

                </b-table>

              </div>



              <form-accordion :title="$t('pain008.info_add')" :isOpen="false" :isTitleUpperCase="false">
                <b-table hover fixed
                  v-if="itemsData.length"
                  :items="itemsOtherDetails"
                  :fields="fieldsOtherDetails"
                  :sort-by="sortField"
                  ref="tablePain008DetailsClose"
                  :id="'table-details' + '-' + randomString">
                  <template #cell(Date)="row_d">
                    <div>
                      {{ convertTime(row_d.item.Date) }}
                    </div>
                  </template>
                </b-table>
              </form-accordion>
              <template v-if="canDoDecision && itemsData.filter(elem => elem.idrequest === request[currentIndexData].idrequest && elem.StatusValidation === '1').length">
                <b-row class="justify-content-end mt-4">
                  <b-col md="2" cols="6" class="mt-3">
                    <b-button @click="refuser()" class="btn">
                      {{ $t('pain008.refus') }}
                    </b-button>
                  </b-col>
                  <b-col md="2" cols="6" class="mt-3">
                    <b-button @click="validate()" variant="primary">
                      {{ $t('pain008.validate') }}
                    </b-button>
                  </b-col>
                </b-row>
              </template>
            </div>

            <!-- Tableau historique des modifications -->
            <div v-if="currentTab === 'historique'">

              <div v-if="itemsHisto.length">
                <b-table hover responsive sticky-header
                  :items="itemsHisto"
                  :fields="fieldsHisto"
                  :sort-by="sortField"
                  ref="tablePain008HistoClose"
                  :id="'table-histo' + '-' + randomString">
                  <template #cell(stateVerif)="row">
                    <div>
                      {{ verifStatus(row.item.stateVerif) }}
                    </div>
                  </template>
                  <template #cell(StatusValidation)="row">
                    <template v-if="row.item.StatusValidation === '2' || row.item.StatusValidation === '6'">
                      <div>
                        {{ $t('pain008.validated') }}
                      </div>
                    </template>
                    <template v-if="row.item.StatusValidation === '3'">
                      <div>
                        {{ $t('pain008.denied') }}
                      </div>
                    </template>
                  </template>
                </b-table>

                <b-row class="mt-5">
                  <b-col>
                    <b-col cols="12">
                      <cm-pagination
                        :maxResultsByPage="paginationObjectHisto.maxResults"
                        :firstIndex="paginationObjectHisto.firstIndex"
                        :nbResultsTotal="paginationObjectHisto.nbResultsTotal"
                        :refreshEvent="paginationObjectHisto.refresh">
                      </cm-pagination>
                    </b-col>
                  </b-col>
                </b-row>

                <b-row class="justify-content-end mt-5" v-if="itemsHisto.length">
                  <b-col lg="2" offset="10" class="mt-3">
                    <b-button variant="primary"
                      @click="extractCSV_itemsHisto()">
                      <i class="fa-solid fa-arrow-up-from-bracket"></i>
                      {{ $t('pain008.extract_list') }}
                    </b-button>
                  </b-col>
                </b-row>
              </div>
              <div v-else class="d-flex justify-content-center">
                <span class="noResult">
                  {{ $t('pain008.no_update') }}
                </span>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>

<script>
import moment from 'moment'
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'

import MessagesFilter from '@/pages/pain008/components_Traitement/'
import MessagesFilter1 from '@/pages/pain008/components_Traitement_Données/'
import pagination from '@/components/common/pagination.vue'
//import pagination1 from '@/components/common/pagination.vue'
import FormAccordion from '@/components/common/FormAccordion.vue'
import Spinner from '@/components/common/spinner.vue'

export default {
  name: 'Traitement_Page',
  components: {
    'cm-messages-filter': MessagesFilter,
    'cm-messages-filter-1': MessagesFilter1,
    'cm-pagination': pagination,
    'form-accordion': FormAccordion,
    'page-outline': PageOutline,
    'spinner': Spinner
  },
  props: {
    direction: {
      default: '2',
      type: String
    },
    modeFilter: {
      default: '1',
      type: String
    }
  },
  computed: {
    canDoDecision () {
      return this.$engine.rights.rightIs('Pain08_UpdateStatusValidation_ajouter', true)
    },
    canSeeDetails () {
      return this.$engine.rights.rightIs('Pain08_dataFile_ajouter', true)
    },
    canSeeHisto () {
      return this.$engine.rights.rightIs('Pain08_histoFile_consulter', true)
    },
    fields () {
      return [
        { key: 'fileImport', label: this.$t('pain008.nameFile'), class: 'text-left', sortable: true },
        { key: 'dateImport', label: this.$t('pain008.date_import'), class: 'text-center', sortable: true },
        // { key: 'nbTotalElem', label: this.$t('pain008.total_number_item_expect'), class: 'text-center' },
        { key: 'total', label: this.$t('pain008.total'), class: 'text-center', sortable: true },
        { key: 'process', label: this.$t('pain008.being_processed'), class: 'text-center', sortable: true },
        { key: 'verif', label: this.$t('pain008.to_verify'), class: 'text-center', sortable: true },
        { key: 'validated', label: this.$t('pain008.validated'), class: 'text-center', sortable: true },
        { key: 'refus', label: this.$t('pain008.refused'), class: 'text-center', sortable: true },
        { key: 'error', label: this.$t('pain008.in_error'), class: 'text-center', sortable: true },
        { key: 'ignored', label: this.$t('pain008.ignored'), class: 'text-center', sortable: true },
        { key: 'paid', label: this.$t('pain008.paid'), class: 'text-center', sortable: true }
        // { key: 'globalState', label: this.$t('pain008.stat_global'), class: 'text-center' }
      ]
    },
    fieldsDataPP () {
      return [
        { key: 'name', label: this.$t('pain008.name'), class: 'text-center', sortable: true },
        { key: 'iban', label: this.$t('pain008.iban'), class: 'text-center', sortable: true },
        { key: 'verifIban', label: this.$t('pain008.iban_verification'), class: 'text-center', sortable: true },
        { key: 'score', label: this.$t('pain008.score'), class: 'text-center', sortable: true },
        { key: 'stateVerif', label: this.$t('pain008.verification_status'), class: 'text-center', sortable: true },
        { key: 'validAll', label: '', class: 'text-center position-relative' },
        { key: 'rejectAll', label: '', class: 'text-center position-relative' },
        { key: 'paid', label: '', class: 'text-center position-relative' }
      ]
    },
    fieldsDataPM () {
      return [
        { key: 'name', label: this.$t('pain008.company_name'), class: 'text-center', sortable: true },
        { key: 'iban', label: this.$t('pain008.iban'), class: 'text-center', sortable: true },
        { key: 'siren', label: this.$t('pain008.siren'), class: 'text-center', sortable: true },
        { key: 'verifIban', label: this.$t('pain008.iban_verification'), class: 'text-center', sortable: true },
        { key: 'verifSiren', label: this.$t('pain008.siren_verification'), class: 'text-center', sortable: true },
        /* { key: 'score', label: this.$t('pain008.score'), class: 'text-center' }, */
        { key: 'stateVerif', label: this.$t('pain008.verification_status'), class: 'text-center', sortable: true },
        { key: 'validAll', label: '', class: 'text-center position-relative' },
        { key: 'rejectAll', label: '', class: 'text-center position-relative' },
        { key: 'paid', label: '', class: 'text-center position-relative' }
      ]
    },
    fieldsDetails () {
      return [
        { key: 'field', label: this.$t('pain008.contact_details'), class: 'text-left text-green' },
        { key: 'value', label: this.$t('pain008.value'), class: 'text-center' },
        { key: 'result', label: this.$t('pain008.result_scoring_verification'), class: 'text-center' },
        { key: 'details', label: this.$t('pain008.details'), class: 'text-center' }
      ]
    },
    fieldsHisto () {
      return [
        { key: 'Date', label: this.$t('pain008.date'), class: 'text-center', sortable: true },
        { key: 'Login', label: this.$t('pain008.user'), class: 'text-center', sortable: true },
        { key: 'iban', label: this.$t('pain008.iban'), class: 'text-center', sortable: true },
        { key: 'stateVerif', label: this.$t('pain008.verification_status'), class: 'text-center', sortable: true },
        { key: 'StatusValidation', label: this.$t('pain008.remittance_status'), class: 'text-center', sortable: true }
      ]
    },
    fieldsOtherDetails () {
      return [
        { key: 'EndToEndId', label: this.$t('pain008.identifier'), class: 'text-center'},
        { key: 'CreditorName', label: this.$t('pain008.name'), class: 'text-center'},
        { key: 'Date', label: this.$t('pain008.date'), class: 'text-center'},
        // { key: 'Priority', label: this.$t('pain008.priority'), class: 'text-center'},
        // { key: 'Bic', label: this.$t('pain008.bic_iban_check'), class: 'text-center'},
        { key: 'Amount', label: this.$t('pain008.amount'), class: 'text-center'}
      ]
    },
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    nbBeingProcessedRequest () {
      return !this.items[this.currentIndexList].process || this.items[this.currentIndexList].process === 0 ? '-' : this.items[this.currentIndexList].process
    },
    nbErrorRequest () {
      return !this.items[this.currentIndexList].error || this.items[this.currentIndexList].error === 0 ? '-' : this.items[this.currentIndexList].error
    },
    nbIgnoredRequest () {
      return !this.items[this.currentIndexList].ignored || this.items[this.currentIndexList].ignored === 0 ? '-' : this.items[this.currentIndexList].ignored
    },
    nbPaidRequest () {
      return !this.items[this.currentIndexList].paid || this.items[this.currentIndexList].paid === 0 ? '-' : this.items[this.currentIndexList].paid
    },
    nbRefusedRequest () {
      return !this.items[this.currentIndexList].refus || this.items[this.currentIndexList].refus === 0 ? '-' : this.items[this.currentIndexList].refus
    },
    nbToVerifyRequest () {
      return !this.items[this.currentIndexList].verif || this.items[this.currentIndexList].verif === 0 ? '-' : this.items[this.currentIndexList].verif
    },
    nbTotalRequest () {
      return !this.items[this.currentIndexList].total || this.items[this.currentIndexList].total === 0 ? '-' : this.items[this.currentIndexList].total
    },
    nbValidatedRequest () {
      return !this.items[this.currentIndexList].validated || this.items[this.currentIndexList].validated === 0 ? '-' : this.items[this.currentIndexList].validated
    },
    type () {
      return this.tabType === 0 ? 'PM' : 'PP'
    }
  },
  watch: {
    // whenever question changes, this function will run
    tabType(newQuestion, oldQuestion) {
      //this.currentIndexList = 0
      this.itemsDetails = []
      this.showData(this.idfiledata)
    }
  },
  data () {
    return {
      activateSpinner: false,
      allcheckedReject: false,
      allcheckedValid: false,
      completeList: [],
      currentIndex: 0,
      currentIndexData: 0,
      currentIndexHistorique: 0,
      currentIndexList: 0,
      currentTab: 'list',
      fieldsDetailsControlsPM: ['IBAN', 'Type', 'SIREN'],
      fieldsDetailsControlsPP: ['IBAN', 'Type', 'Name', 'OtherName'],
      // fieldsHistorique: [
      //   { key: 'Date', label: this.$t('pain008.date'), class: 'text-center font-weight-bold' },
      //   { key: 'TypeValue', label : this.$t('pain008.data_type'), class: 'text-center font-weight-bold'},
      //   { key: 'OldValue', label: this.$t('pain008.old_value'), class: 'text-center font-weight-bold' },
      //   { key: 'NewValue', label: this.$t('pain008.new_value'), class: 'text-center font-weight-bold' }
      // ],
      filterConditions: { Status: [] },
      filterConditionsData: { Status: [] },
      get_status: [],
      idfiledata: 0,
      idrequest: [],
      items: [],
      itemsData: [],
      itemsDataPP: [],
      itemsDataPM: [],
      itemsDetails: [],
      itemsHisto: [],
      itemsOtherDetails: [],
      max: 0,
      min: 0,
      mode: 1,
      noMore: false,
      pageCounter: 0,
      paginationObject: {},
      paginationObjectData: {},
      paginationObjectHisto: {},
      randomId: Math.random().toString(36).substr(2, 10),
      randomString: '',
      request: [],
      scrollFlag: true,
      serviceId: this.$engine.user.currentService.id.toString(),
      sortBy: '',
      sortByData: '',
      sortDir: false,
      sortDirData: false,
      sortField: 'debtor_name',
      sortFieldData: 'debtor_name',
      tabType: 0,
      value: 0,
      isMouseOver : {},
    }
  },
  created () {
    let that = this

    if (this.filterConditions) {
      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }
    }
    if (this.filterConditionsData) {
      if (this.filterConditionsData.OrderByField) {
        this.sortByData = this.filterConditionsData.OrderByField
      }
      if (this.filterConditionsData.OrderByDirection) {
        this.sortDirData = this.filterConditionsData.OrderByDirection === 'DESC'
      }
    }

    this.reload = false
    this.randomString = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5)

    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content: start',
      navTitle: this.listTitle,
      returnUrl: ''
    })

    this.paginationObject.firstIndex = 1
    this.paginationObject.maxResults = 10
    this.paginationObject.nbResultsTotal = 0

    this.paginationObjectData.firstIndex = 1
    this.paginationObjectData.maxResults = 10
    this.paginationObjectData.nbResultsTotal = 0

    this.paginationObjectHisto.firstIndex = 1
    this.paginationObjectHisto.maxResults = 10
    this.paginationObjectHisto.nbResultsTotal = 0

    this.paginationObject.refresh = 'traitement-page'
    this.$bus.$off('traitement-page')
    this.$bus.$on('traitement-page', index => {
      that.reload = true
      that.onRefresh(false, index)
      that.pageCounter = 0
    })
    this.paginationObjectData.refresh = 'traitement-details'
    this.$bus.$off('traitement-details')
    this.$bus.$on('traitement-details', index => {
      that.reload = true
      that.showData(that.idfiledata, index)
      that.pageCounter = 0
    })
    this.paginationObjectHisto.refresh = 'traitement-histo'
    this.$bus.$off('traitement-histo')
    this.$bus.$on('traitement-histo', index => {
      that.reload = true
      that.showHisto(that.idfiledata, index)
      that.pageCounter = 0
    })




    // let that = this
    // this.$f7.params.swipePanel = that.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
    // this.$f7.params.panelsCloseByOutside = that.$engine.services.directPayments.filter.smartphoneStorage

    // this.$f7.params.swipePanel = that.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
    // this.$f7.params.panelsCloseByOutside = that.$engine.services.directPayments.filter.smartphoneStorage

    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    this.onRefresh(false)
  },
  mounted () {
    this.$$('.infinite-scroll-preloader').remove()
    this.$bus.on('service:change', (val) => {
      this.serviceId = this.$engine.getServiceIdByName(val)
    })
  },
  methods: {
    allLineSelect (decision) {
      if (decision === 'ValideAll') {
        let i = 0
        while ((i < this.itemsData.length) && (this.itemsData[i].validAll === true)) {
          i++
        }
        if (i === this.itemsData.length) {
          this.allcheckedValid = true
        }
      } else if (decision === 'rejectAll') {
        let i = 0
        while ((i < this.itemsData.length) && (this.itemsData[i].rejectAll === true)) {
          i++
        }
        if (i === this.itemsData.length) {
          this.allcheckedReject = true
        }
      }
    },
    applyFilter (filterConditions, index = 1) {
      this.reload = true
      if (filterConditions.modeFilter !== undefined && filterConditions.modeFilter !== this.mode) {
        this.mode = filterConditions.modeFilter
      }

      this.pageCounter = 0
      this.paginationObject.firstIndex = index
      this.paginationObject.nbResultsTotal = 0

      if (!filterConditions.Status || !filterConditions.Status.length) {
        filterConditions.Status = [0,1,2,3,4,98,99]
      }

      this.activateSpinner = true

      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }

      this.$engine.pain08.update(
        filterConditions,
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
      ).then(resp => {
        if (resp.data && resp.data.Results) {
          let requests = {}
          this.paginationObject.nbResultsTotal = resp.data.nbTotalResults
          this.paginationObject.nbResults = resp.data.Results.length
          requests = resp.data.Results
          this.updateItems(requests)
          this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
        }
        this.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, this, this.$i18n)
      })
    },
    applyFilterData (filterConditions, index = 1) {
      this.activateSpinner = true
      let filterConditionsFile = {}

      filterConditionsFile.IdFile = this.items[this.currentIndexList].IdFile
      this.paginationObjectData.firstIndex = index
      this.paginationObjectData.nbResultsTotal = 0

      if (this.filterConditionsData.OrderByField) {
        this.sortByData = this.filterConditionsData.OrderByField
      }
      if (this.filterConditionsData.OrderByDirection) {
        this.sortDirData = this.filterConditionsData.OrderByDirection === 'DESC'
      }

      let that = this
      this.$engine.pain08.update(
        filterConditionsFile,
        this.paginationObjectData.maxResults,
        this.paginationObjectData.firstIndex
      ).then(resp => {
        if (resp.data && resp.data) {
          let request = {}
          request = resp.data.Results[0]
          that.updateItem(that.items[that.currentIndexList], request)
          that.reload = true
          if (filterConditions.modeFilter !== undefined && filterConditions.modeFilter !== that.mode) {
            that.mode = filterConditions.modeFilter
          }

          filterConditions.Type = that.type

          that.allcheckedValid = false
          that.allcheckedReject = false
          filterConditions.IdFile = that.idfiledata
          that.$engine.pain08.getFileInfo(filterConditions)
          .then(resp => {
            let requests = []
            that.paginationObjectData.nbResultsTotal = resp.data.nbTotalResults
            that.paginationObjectData.nbResults = resp.data.Results.length
            requests = resp.data.Results
            that.updateItemsData(requests)
            that.$bus.emit('refresh-cache-paging-template', that.paginationObjectData)
            that.activateSpinner = false
          })
          .catch(error => {
            that.activateSpinner = false
            errorMessageAlert(error, that, that.$i18n)
          })
        }
      })
      .catch(error => {
        this.activateSpinner = false
        errorMessageAlert(error, this, this.$i18n)
      })
    },
    attachInfinit () {
      this.$f7.attachInfiniteScroll(this.$$('.infinite-scroll'))
      this.scrollFlag = true
      this.noMore = false
    },
    choix (valid, refus) {
      let result = ''
      if (valid === true) {
        result = '2'
      } else if (refus === true) {
        result = '3'
      }
      return result
    },
    checkStatus (status) {
      if (status && (status === this.$t('pain008.file_refused') ||
      status === this.$t('pain008.lock') ||
      status === this.$t('pain008.finish'))) {
        return false
      } else {
        return true
      }
    },
    choseTable (table) {
      switch (table) {
        case 'list':
          this.currentTab = 'list'
          this.onRefresh()
          break
        case 'data':
          if (this.idfiledata !== 0) {
            this.currentTab = 'data'
          }
          break
        case 'details':
          if (this.itemsDetails.length) {
            this.currentTab = 'details'
          }
          break
        case 'historique':
          this.currentTab = 'historique'
          break
        default:
          this.currentTab = 'list'
          break
      }
    },
    cloturer (idFile) {
      let status = 5
      this.idfiledata = idFile
      this.$engine.pain08.updateCloturer(this.idfiledata, status)
      this.onRefresh()
    },
    convertTime (time) {
      return (moment(time).format('DD/MM/YYYY [à] HH[h]mm'))
    },
    dateScore (requests) {
      let score = ''
      let str = requests.split(',')
      for (let i = 0; i < str.length; i++) {
        if ((str[i] >= '09000' && str[i] <= '09400') || (str[i] >= '10000' && str[i] <= '10400')) {
          score = str[i].slice(2)
        }
      }
      return score
    },
    decideLine (row, decision) {
      if (this.allcheckedValid && decision === 1) {
        this.allcheckedValid = false
      } else if (this.allcheckedValid && decision === 0) {
        this.allcheckedValid = false
      } else if (this.allcheckedReject && decision === 1) {
        this.allcheckedReject = false
      } else if (this.allcheckedReject && decision === 0) {
        this.allcheckedReject = false
      }

      if (decision === 0) {
        row.item.validAll = false
      } else if (decision === 1) {
        row.item.rejectAll = false
      }
      this.allLineSelect('ValideAll')
      this.allLineSelect('rejectAll')
    },
    detachInfinit () {
      this.$$('.infinite-scroll-preloader').remove()
      this.$f7.detachInfiniteScroll(this.$$('.infinite-scroll'))
      this.$engine.settings.set({sendboxPreloaderRemoved: true})
      if (!this.emptyBox) {
        this.scrollFlag = false
        this.noMore = true
      }
    },
    effacer () {
      this.allcheckedReject = false
      this.allcheckedValid = false
      for (let index = 0; index < this.itemsData.length; index++) {
          this.itemsData[index].validAll = false
          this.itemsData[index].rejectAll = false
      }
    },
    enregistrer () {
      let result = []
      for (let index = 0; index < this.itemsData.length; index++) {
        let action = {
          idrequest: this.idrequest[index],
          choice: this.choix(this.itemsData[index].validAll, this.itemsData[index].rejectAll)
        }
        if (action.choice !== '') {
          result.push(action)
        }
      }
      //let that = this
      let nbValidated = result.filter(elem => elem.choice === '2').length
      let nbRefused = result.filter(elem => elem.choice === '3').length
      // if (this) {
      //   console.log('result', result)
      //   console.log('nb validé', result.filter(elem => elem.choice === '4').length)
      //   console.log('nb refusés', result.filter(elem => elem.choice === '3').length)
      //   return
      // }
      this.$engine.pain08.updateDecision(this.idfiledata, result)
      .then((resp) => {
        if (this.items[this.currentIndexList].validated === '-') {
          this.items[this.currentIndexList].validated = 0
        }
        if (this.items[this.currentIndexList].refus === '-') {
          this.items[this.currentIndexList].refus = 0
        }
        if (this.items[this.currentIndexList].verif === '-') {
          this.items[this.currentIndexList].verif = 0
        }
        this.items[this.currentIndexList].verif -= result.length
        this.items[this.currentIndexList].validated += nbValidated
        this.items[this.currentIndexList].refus += nbRefused
        this.showData(this.idfiledata, this.currentIndexList)
      })

      this.showData(this.idfiledata, this.currentIndexList)
    },
    extractCSV_items () {
      let filterConditions
      if (this.reload) {
        filterConditions =
          this.$engine.pain08.filter.getConditionObject()
      } else {
        filterConditions =
          this.$engine.pain08.filter.getDefaultFilter()
      }

      if (!filterConditions.Status || !filterConditions.Status.length) {
        filterConditions.Status = [0,1,2,3,4,98,99]
      }

      this.$engine.pain08.update(filterConditions).then(resp => {
        let requests = {}
        requests = resp.data.Results
        //this.updateItems(requests)
        this.extractItems(requests)
        this.currentTab = 'list'

        //this.activateSpinner = false
      })
      .catch(error => {
        //this.activateSpinner = false
        errorMessageAlert(error, this, this.$i18n)
      })
    },
    extractCSV_itemsData () {
      let filterConditions = {}
      filterConditions.IdFile = this.idfiledata
      let that = this
      this.$engine.pain08.getFileInfo(filterConditions)
      .then(resp => {
        let requests = {}
        requests = resp.data.Results
        that.$engine.pain08.getFileHistory({
          IdFile: that.idfiledata,
          OnlyLast: '1',
          OrderNumberMin: '2'
        })
        .then(resp => {
          let requests2 = {}
          requests2 = resp.data.Results
          this.extractItemsData(requests, requests2)
        })
        .catch(error => {
          errorMessageAlert(error, this, this.$i18n)
        })
      })
      .catch(error => {
        errorMessageAlert(error, this, this.$i18n)
      })
    },
    extractCSV_itemsHisto () {
      this.$engine.pain08.getFileHistory({
        IdFile: this.idfiledata,
        OnlyLast: '1',
        OrderNumberMin: '2'
      })
      .then(resp => {
        let requests = {}
        requests = resp.data.Results
        this.extractItemsHisto(requests)
      })
      .catch(error => {
        errorMessageAlert(error, this, this.$i18n)
      })
    },
    extractItems (requests) {
      let firstLine = ''
      let lines = ''
      let fileName = ''
      let today = moment()
      firstLine = this.$t('pain008.nameFile') + ';' +
        this.$t('pain008.date_import') + ';' +
        this.$t('pain008.total') + ';' +
        this.$t('pain008.being_processed') + ';' +
        this.$t('pain008.to_verify') + ';' +
        this.$t('pain008.validated') + ';' +
        this.$t('pain008.refused') + ';' +
        this.$t('pain008.in_error') + ';' +
        this.$t('pain008.ignored') + ';' +
        this.$t('pain008.paid') + '\r\n'
      fileName = 'extractRemittanceList' + today.unix() + '.csv'

      for (let k in requests) {
        let dateImport = ''
        dateImport = requests[k].DateImport

        lines += requests[k].NameFile + ';' +
        this.convertTime(dateImport) + ';' +
        requests[k].NbTotal + ';' +
        requests[k].NbBeingProcessed + ';' +
        requests[k].NbVerify + ';' +
        requests[k].NbValide + ';' +
        requests[k].NbReject + ';' +
        requests[k].NbError + ';' +
        requests[k].NbIgnored + ';' +
        requests[k].NbPaid + '\r\n'
      }
      let data = firstLine + lines
      let linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(data)
      let downloadLink = document.createElement('a')
      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.click()
    },
    extractItemsData (requests, requests2) {
      let firstLine = ''
      let lines = ''
      let fileName = ''
      let today = moment()
      firstLine = this.$t('pain008.identifier') + ';' +
        this.$t('pain008.name') + ';' +
        this.$t('pain008.iban') + ';' +
        this.$t('pain008.fields.Type') + ';' +
        this.$t('pain008.siren') + ';' +
        this.$t('pain008.iban_verification') + ';' +
        this.$t('pain008.siren_verification') + ';' +
        this.$t('pain008.score') + ';' +
        this.$t('pain008.amount') + ';' +
        this.$t('pain008.verification_status') + ';' +
        this.$t('pain008.remittance_status') + ';' +
        this.$t('pain008.date_histo') + ';' +
        this.$t('pain008.user') + ';' +
        this.$t('pain008.file_date') + ';' +
        this.$t('pain008.file_name') + ';' +
        this.$t('pain008.nb_total') + ';' +
        this.$t('pain008.nb_refused') + ';' +
        this.$t('pain008.nb_paid') + ';' +
        this.$t('pain008.amount_total') + ';' +
        this.$t('pain008.amount_paid') + '\r\n'
      fileName = 'extractRemittanceData' + today.unix() + '.csv'
      let amountTotal = 0
      let amountPaid = 0
      for (let k in requests) {
        let ibanCode = requests[k].ReturnCode.match(/01\d\d\d/i)
        let iconVerifIban = ''
        if (ibanCode) {
          iconVerifIban = this.verifAll(ibanCode[0], 'IBAN')
        }

        let checkStatusValidation
        if (requests[k].StatusValidation === '2') {
          checkStatusValidation = this.$t('pain008.validated')
        } else if (requests[k].StatusValidation === '3') {
          checkStatusValidation = this.$t('pain008.denied')
        } else if (requests[k].StatusValidation === '4') {
          checkStatusValidation = this.$t('pain008.error')
        } else if (requests[k].StatusValidation === '5') {
          checkStatusValidation = this.$t('pain008.ignored')
        } else if (requests[k].StatusValidation === '6') {
          checkStatusValidation = this.$t('pain008.paid')
        } else {
          checkStatusValidation = ''
        }

        let sirenCode = requests[k].ReturnCode.match(/03\d\d\d/i)
        let iconVerifSiren = ''
        if (sirenCode) {
          iconVerifSiren = this.verifAll(sirenCode[0], 'SIREN')
        }

        let typeowner
        if (requests[k].Type === 'PP'){
          typeowner = this.$t('pain008.PP')
        } else {
          typeowner = this.$t('pain008.PM')
        }

        let score = this.dateScore(requests[k].ReturnCode)

        let idrequest = requests[k].idrequest
        let dateModif = ''
        let loginModif = ''
        let modif = requests2.filter(obj => {return obj.Date === idrequest})
        //console.log(idrequest, this.itemsHisto.filter(obj => {return obj.Date === idrequest}), modif.length, modif[0])
        if (modif.length) {
          dateModif = modif[0].Date
          loginModif = modif[0].Login
        }

        amountTotal += parseFloat(requests[k].InstdAmt)
        if (requests[k].StatusValidation === '6') {
          amountPaid += parseFloat(requests[k].InstdAmt)
        }

        lines += requests[k].EndToEndId + ';' +
        requests[k].CreditorName + ';' +
        requests[k].IBAN + ';' +
        typeowner + ';' +
        requests[k].SIREN + ';' +
        iconVerifIban + ';' +
        iconVerifSiren + ';' +
        score + ';' +
        requests[k].InstdAmt.replace('.', ',') + ';' +
        this.verifStatus(requests[k].Verification) + ';' +
        checkStatusValidation + ';' +
        dateModif + ';' +
        loginModif + ';' +
        this.items[this.currentIndexList].dateImport + ';' +
        this.items[this.currentIndexList].fileImport + '\r\n'
        //requests[k].validAll + ';' +
        //requests[k].rejectAll + '\r\n'
      }

      lines += 'x' + ';' +
      'x' + ';' +
      'x' + ';' +
      'x' + ';' +
      'x' + ';' +
      'x' + ';' +
      'x' + ';' +
      'x' + ';' +
      'x' + ';' +
      'x' + ';' +
      'x' + ';' +
      'x' + ';' +
      'x' + ';' +
      'x' + ';' +
      'x' + ';' +
      this.items[this.currentIndexList].total + ';' +
      (parseInt(this.items[this.currentIndexList].refus) + parseInt(this.items[this.currentIndexList].error)) + ';' +
      (parseInt(this.items[this.currentIndexList].ignored) + parseInt(this.items[this.currentIndexList].paid)) + ';' +
      amountTotal.toFixed(2).replace('.', ',') + ';' +
      amountPaid.toFixed(2).replace('.', ',')

      let data = firstLine + lines
      let linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(data)
      let downloadLink = document.createElement('a')
      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.click()
    },
    extractItemsHisto (requests) {
      let firstLine = ''
      let lines = ''
      let fileName = ''
      let today = moment()


      firstLine = this.$t('pain008.date') + ';' +
        this.$t('pain008.user') + ';' +
        this.$t('pain008.iban') + ';' +
        this.$t('pain008.verification_status') + ';' +
        this.$t('pain008.remittance_status') + '\r\n'
      fileName = 'extractRemittanceHisto' + today.unix() + '.csv'

      for (let k in requests) {
        let dateImport = ''
        dateImport = requests[k].DateImport

        let remittanceStatus
        if (requests[k].StatusValidation === '2' || requests[k].StatusValidation === '6') {
          remittanceStatus = this.$t('pain008.validated')
        } else {
          remittanceStatus = this.$t('pain008.denied')
        }

        lines += this.convertTime(requests[k].Date) + ';' +
        requests[k].Login + ';' +
        requests[k].IBAN + ';' +
        this.verifStatus(requests[k].Verification) + ';' +
        remittanceStatus + '\r\n'
      }
      let data = firstLine + lines
      let linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(data)
      let downloadLink = document.createElement('a')
      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.click()
    },
    globalState (request) {
      let status_label = ''
      if (request === '1') {
        status_label = this.$t('pain008.processed_pending')
      } else if (request === '2') {
        status_label = this.$t('pain008.registered')
      } else if (request === '3') {
        status_label = this.$t('pain008.file_refused')
      } else if (request === '4') {
        status_label = this.$t('pain008.waiting_decision_2')
      } else if (request === '5') {
        status_label = this.$t('pain008.finish')
      } else if (request === '6') {
        status_label = this.$t('pain008.state_closed')
      // } else if (request === '7') {
      //   status_label = this.$t('pain008.partially_treaty')
      } else if (request === '98') {
        status_label = this.$t('pain008.eligible_reconstruction')
      } else if (request === '99') {
        status_label = this.$t('pain008.lock')
      }
      return status_label
    },
    navDetails (index) {
      let new_index = index + this.currentIndexData
      this.showDetails(new_index)
    },
    onRefresh (noAttach = false, index = 1) {
      this.pageCounter = 0
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0
      this.activateSpinner = true
      let filterConditions

      if (this.reload) {
        filterConditions = this.$engine.pain08.filter.getConditionObject()
      } else {
        filterConditions = this.$engine.pain08.filter.getDefaultFilter()
      }

      if (!filterConditions.Status || !filterConditions.Status.length) {
        filterConditions.Status = [0,1,2,3,4,98,99]
      }

      //filterConditions.IdFile = '20'

      // filterConditions.sortField = 'SF' + this.sortField
      // filterConditions.sortDirection = this.sortDirection

      // let that = this

      if (this.filterConditions.OrderByField) {
        filterConditions.OrderByField = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        filterConditions.OrderByDirection = this.filterConditions.OrderByDirection
      }

      this.$engine.pain08.update(
        filterConditions,
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex
      ).then(resp => {
        if (resp.data && resp.data) {
          let requests = {}
          this.paginationObject.nbResultsTotal = resp.data.nbTotalResults
          this.paginationObject.nbResults = resp.data.Results.length
          requests = resp.data.Results
          this.updateItems(requests)
          this.$f7.pullToRefreshDone()
          this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
        }
        this.currentTab = 'list'

        this.activateSpinner = false
      })
      .catch(error => {
        this.activateSpinner = false
        errorMessageAlert(error, this, this.$i18n)
      })
    },
    progressBar (index) {
      this.value = parseInt(this.items[index].validated) + parseInt(this.items[index].refus)
      this.max = this.items[index].total
    },
    refreshInbox () {
      this.onRefresh()
    },
    refuser () {
      let result = []
      let action = {
          idrequest: this.idrequest[this.currentIndex],
          choice: '3'
      }
      result.push(action)
      let nbRefused = result.filter(elem => elem.choice === '3').length
      this.$engine.pain08.updateDecision(this.idfiledata, result)
      .then((resp) => {
        if (this.items[this.currentIndexList].refus === '-') {
          this.items[this.currentIndexList].refus = 0
        }
        this.items[this.currentIndexList].verif -= result.length
        this.items[this.currentIndexList].refus += nbRefused
      })
      this.showData(this.idfiledata, this.currentIndexList)
    },
    resendExpired () {
      if (!this.canSeeDetails) {
        return
      }
      this.activateSpinner = true

      if (this.paginationObjectData.firstIndex === 0) {
        this.paginationObjectData.firstIndex = 1
      }
      let that = this

      let filterConditions
      filterConditions = {
        IdFile: this.idfiledata,
        Status: [12],
        StatusVerification: [1]
      }
      this.$engine.pain08.getFileInfo(filterConditions)
      .then(resp => {
        let requests = []
        if (resp && resp.data) {
          requests = resp.data.Results
          if (requests.length > 0) {
            that.$f7.showPreloader(that.$i18n.t('loading.resend_diamond'))
            let nbSent = 0
            for (let index = 0; index < requests.length; index++) {
              that.$engine.services.lucy.replace({
                IdDocument: that.idfiledata,
                IdLucyRequest: requests[index].idrequest
              })
              .then(resp => {
                nbSent++
                if (nbSent === requests.length) {
                  that.$f7.hidePreloader()
                  that.$f7.alert(that.$i18n.t('lucy.resend_succeed_long'), that.$i18n.t('lucy.resend_succeed'))
                  this.showData(this.idfiledata)
                }
              })
              .catch(error => {
                errorMessageAlert(error, that)
              })
            }
          } else {
            that.$f7.alert('', that.$i18n.t('lucy.no_resend'))
          }
          // this.request = requests
          // that.updateItemsData(requests)
          // that.$f7.pullToRefreshDone()
          // that.$bus.emit('refresh-cache-paging-template', this.paginationObjectData)

          // that.currentTab = 'data'
          // this.progressBar(index)
        }
        that.activateSpinner = false
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that, that.$i18n)
      })
    },
    selectAll (decision) {
      for (let index = 0; index < this.itemsData.length; index++) {
        if(decision === 'ValideAll') {
          this.allcheckedReject = false
          this.itemsData[index].validAll = (this.allcheckedValid) ? true : false
          this.itemsData[index].rejectAll = false
        } else if (decision === 'rejectAll') {
          this.allcheckedValid = false
          this.itemsData[index].validAll = false
          this.itemsData[index].rejectAll = (this.allcheckedReject) ? true : false
        }
      }
    },
    showData (id, index = 0) {
      if (!this.canSeeDetails) {
        return
      }
      this.activateSpinner = true

      this.allcheckedValid = false
      this.allcheckedReject = false
      this.paginationObjectData.firstIndex = index
      if (this.paginationObjectData.firstIndex === 0) {
        this.paginationObjectData.firstIndex = 1
      }
      this.currentIndexData = index
      this.idfiledata = id
      this.currentIndexList = this.items.map(e => e.IdFile).indexOf(id)
      let that = this

      this.pageCounter = 0
      let filterConditions
      filterConditions = {
        IdFile: id,
        Type: this.type,
        firstIndex: this.paginationObjectData.firstIndex,
        maxResults: this.paginationObjectData.maxResults
      }
      this.$engine.pain08.getFileInfo(filterConditions)
      .then(resp => {
        let requests = []
        if (resp && resp.data) {
          that.paginationObjectData.nbResultsTotal = resp.data.nbTotalResults

          that.paginationObjectData.nbResults = resp.data.Results.length

          requests = resp.data.Results
          this.request = requests
          that.updateItemsData(requests)
          that.$f7.pullToRefreshDone()
          that.$bus.emit('refresh-cache-paging-template', this.paginationObjectData)

          that.currentTab = 'data'
          // this.progressBar(index)
        }
        that.activateSpinner = false
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that, that.$i18n)
      })

      if (this.canSeeHisto) {
        this.$engine.pain08.getFileHistory({
          IdFile: id,
          OnlyLast: '1',
          OrderNumberMin: '2',
          firstIndex: this.paginationObjectData.firstIndex,
          maxResults: this.paginationObjectData.maxResults
        })
        .then(resp => {
          let requests = []
          if (resp && resp.data) {
            that.paginationObjectHisto.nbResultsTotal = resp.data.nbTotalResults

            that.paginationObjectHisto.nbResults = resp.data.Results.length

            requests = resp.data.Results
            // this.request = requests
            that.updateItemsHisto(requests)
            that.$f7.pullToRefreshDone()
            // that.$bus.emit('refresh-cache-paging-template', this.paginationObjectData)

            // that.currentTab = 'data'
            // this.progressBar(index)
          }
          that.activateSpinner = false
        })
        .catch(error => {
          that.activateSpinner = false
          errorMessageAlert(error, that, that.$i18n)
        })
      }
    },
    showDetails (index) {
      if (this.request[index].StatusValidation === '4') {
        return
      }
      this.currentIndexData = index

      let dateImport = ''
      dateImport = this.request[this.currentIndexData].Date

      let priorityStatus = ''
      priorityStatus = this.request[this.currentIndexData].Priorite

      if (priorityStatus === 1) {
        priorityStatus = this.$t('pain008.high')
      }

      this.itemsOtherDetails = []
      if (dateImport !== '') {
        this.itemsOtherDetails.push({
          CreditorName: this.request[this.currentIndexData].CreditorName,
          Date: dateImport,
          Priority: priorityStatus,
          Bic: this.request[this.currentIndexData].Bic,
          EndToEndId: this.request[this.currentIndexData].EndToEndId,
          Amount: this.request[this.currentIndexData].InstdAmt.replace('.', ',') + ' €'
        })
      }
      let result = this.request[index]
      //console.log("pp ou pm: " + this.request[index].Type)
      if (this.request[index].Type === 'PM') {
        this.updateItemsDetailsPM(result)
      } else if (this.request[index].Type === 'PP') {
        this.updateItemsDetailsPP(result)
      }

      this.currentTab = 'details'
    },
    showHisto (id, index = 0) {
      if (!this.canSeeHisto) {
        return
      }
      this.activateSpinner = true

      this.allcheckedValid = false
      this.allcheckedReject = false
      this.paginationObjectHisto.firstIndex = index
      if (this.paginationObjectHisto.firstIndex === 0) {
        this.paginationObjectHisto.firstIndex = 1
      }
      this.currentIndexData = index
      this.idfiledata = id
      let that = this

      this.pageCounter = 0

      this.$engine.pain08.getFileHistory({
        IdFile: id,
        OnlyLast: '1',
        OrderNumberMin: '2',
        firstIndex: this.paginationObjectHisto.firstIndex,
        maxResults: this.paginationObjectHisto.maxResults
      })
      .then(resp => {
        let requests = []
        if (resp && resp.data) {
          that.paginationObjectHisto.nbResultsTotal = resp.data.nbTotalResults

          that.paginationObjectHisto.nbResults = resp.data.Results.length

          requests = resp.data.Results
          // this.request = requests
          that.updateItemsHisto(requests)
          that.$f7.pullToRefreshDone()
          // that.$bus.emit('refresh-cache-paging-template', this.paginationObjectData)

          that.currentTab = 'historique'
          // this.progressBar(index)
        }
        that.activateSpinner = false
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that, that.$i18n)
      })
    },
    sortTable (key, field, event, isFooter) {
      let sortDirection = 'ASC'
      if (key === this.sortBy && this.sortDir === false) {
        sortDirection = 'DESC'
      }

      this.filterConditions.OrderByField = key
      this.filterConditions.OrderByDirection = sortDirection

      this.applyFilter(this.filterConditions, this.paginationObject.firstIndex)
    },
    sortTableData (key, field, event, isFooter) {
      let sortDirection = 'ASC'
      if (key === this.sortByData && this.sortDirData === false) {
        sortDirection = 'DESC'
      }

      this.filterConditionsData.OrderByField = key
      this.filterConditionsData.OrderByDirection = sortDirection

      this.applyFilterData(this.filterConditionsData, this.paginationObjectData.firstIndex)
    },
    updateInbox (requests, noAttach = false) {
      this.itemsData = requests
      if (requests.length === this.paginationObject['maxResults']) {
        if (!noAttach) {
          this.attachInfinit()
        }
      } else {
        this.detachInfinit()
      }
    },
    updateItem (item, request) {
      let DetailsOK = []
      let DetailsKO = []
      if (request.DetailsOK) {
        for (var j = 0; j < request.DetailsOK.length; j++) {
          let dateimportOK = request.DetailsOK[j].dateimport
          if (dateimportOK) {
            dateimportOK = this.convertTime(dateimportOK)
          }
          let detailsOK = {
            namefile: request.DetailsOK[j].namefile,
            dateimport: dateimportOK,
            nblignes: request.DetailsOK[j].nblignes
          }
          DetailsOK.push(detailsOK)
        }

        for (var z = 0; z < request.DetailsKO.length; z++) {
          let dateimportKO = request.DetailsKO[z].dateimport
          if (dateimportKO) {
            dateimportKO = this.convertTime(dateimportKO)
          }
          let detailsKO = {
            namefile: request.DetailsKO[z].namefile,
            dateimport: dateimportKO,
            nblignes: request.DetailsKO[z].nblignes
          }
          DetailsKO.push(detailsKO)
        }
      }

      let dateImport = ''
      dateImport = request.DateImport

      let globalState = ''
      globalState = request.Status
      if (globalState !== '') {
        globalState = this.globalState(globalState)
      }

      item.IdFile = request.IdFile === '' ? '-' : request.IdFile
      //item.Type = request.Type === '' ? '-' : request.Type
      item.fileImport = request.NameFile === '' ? '-' : request.NameFile
      item.dateImport = dateImport === '' ? '-' : dateImport
      item.total = parseInt(request.NbTotal)
      item.error = parseInt(request.NbError)
      item.ignored = parseInt(request.NbIgnored)
      item.paid = parseInt(request.NbPaid)
      item.validated = parseInt(request.NbValide)
      item.verif = parseInt(request.NbVerify)
      item.refus = parseInt(request.NbReject)
      item.process = parseInt(request.NbBeingProcessed)
      item.globalState = globalState
      item.detailsOK = DetailsOK
      item.detailsKO = DetailsKO
    },
    updateItems (requests) {
      this.items = []
      for (let i = 0; i < requests.length; i++) {
        let DetailsOK = []
        let DetailsKO = []
        if (requests[i].DetailsOK) {
          for (let j = 0; j < requests[i].DetailsOK.length; j++) {
            let dateimportOK = requests[i].DetailsOK[j].dateimport
            if (dateimportOK) {
              dateimportOK = this.convertTime(dateimportOK)
            }
            let detailsOK = {
              namefile: requests[i].DetailsOK[j].namefile,
              dateimport: dateimportOK,
              nblignes: requests[i].DetailsOK[j].nblignes
            }
            DetailsOK.push(detailsOK)
          }

          for (let z = 0; z < requests[i].DetailsKO.length; z++) {
            let dateimportKO = requests[i].DetailsKO[z].dateimport
            if (dateimportKO) {
              dateimportKO = this.convertTime(dateimportKO)
            }
            let detailsKO = {
              namefile: requests[i].DetailsKO[z].namefile,
              dateimport: dateimportKO,
              nblignes: requests[i].DetailsKO[z].nblignes
            }
            DetailsKO.push(detailsKO)
          }
        }

        let dateImport = ''
        dateImport = requests[i].DateImport

        let globalState = ''
        globalState = requests[i].Status
        if (globalState !== '') {
          globalState = this.globalState(globalState)
        }

        let result = {
          IdFile: requests[i].IdFile === '' ? '-' : requests[i].IdFile,
          //Type: requests[i].Type === '' ? '-' : requests[i].Type,
          fileImport: requests[i].NameFile === '' ? '-' : requests[i].NameFile,
          dateImport: dateImport === '' ? '-' : dateImport,
          total: parseInt(requests[i].NbTotal),
          error: parseInt(requests[i].NbError),
          ignored: parseInt(requests[i].NbIgnored),
          paid: parseInt(requests[i].NbPaid),
          validated: parseInt(requests[i].NbValide),
          verif: parseInt(requests[i].NbVerify),
          refus: parseInt(requests[i].NbReject),
          process: parseInt(requests[i].NbBeingProcessed),
          globalState: globalState,
          detailsOK : DetailsOK,
          detailsKO: DetailsKO
        }
        this.items.push(result)
        // DDE - 10/02/2023 on exclut les fichiers clos et les fichiers terminés de la liste
        this.items = this.items.filter(item => item.globalState != this.$t('pain008.state_closed') && item.globalState != this.$t('pain008.finish'))
      }
    },
    updateItemsData (requests) {
      this.itemsData = []
      this.itemsDataPP = []
      this.itemsDataPM = []
      this.idrequest = []
      for (var i = 0; i < requests.length; i++) {
        this.idrequest.push(requests[i].idrequest)
        let result = {
          name: requests[i].CreditorName,
          iban: requests[i].IBAN === '' ? '-' : requests[i].IBAN,
          siren: requests[i].SIREN === '' ? '-' : requests[i].SIREN,
          type: requests[i].Type === 'PP' ? 'PP' : 'PM',
          verifIban: this.verifIban(requests[i].ReturnCode) === '' ? '-' : this.verifIban(requests[i].ReturnCode),
          verifSiren: this.verifSiren(requests[i].ReturnCode) === '' ? '-' : this.verifSiren(requests[i].ReturnCode),
          StatusValidation: requests[i].StatusValidation,
          idrequest: requests[i].idrequest,
          score: this.dateScore(requests[i].ReturnCode) === '' ? '-' : this.dateScore(requests[i].ReturnCode),
          stateVerif: requests[i].Verification,
          validAll: false,
          rejectAll: false,
          paid: false
        }
        if (requests[i].Type === 'PP'){
          this.itemsDataPP.push(result)
        } else if (requests[i].Type==='PM'){
          this.itemsDataPM.push(result)
        }
        this.itemsData.push(result)
      }
    },
    updateItemsDetailsPM (request) {
      this.itemsDetails = []
      for (let x = 0; x < this.fieldsDetailsControlsPM.length; x++) {
        let field = this.fieldsDetailsControlsPM[x]
        let value = request[field]
        let result = ''
        switch (field) {
          case 'IBAN': // 01xxx
            result = this.verifIban(request.ReturnCode)
            break
          case 'SIREN': // 03xxx
            result = this.verifSiren(request.ReturnCode)
            break
          case 'Type': // 02xxx
            result = this.verifType(request.ReturnCode)
            break
          // case 'BirthDate': // 06xxx
          //   result = this.verifBirthDate(request.ReturnCode)
          //   break
          // case 'Name': // 09xxx
          //   result = this.verifName(request.ReturnCode)
          //   break
          // case 'OtherName': // 10xxx
          //   result = this.verifOtherName(request.ReturnCode)
          //   break
          default:
            break
        }
        // if (field === 'BirthDate') {
        //   value = moment(value).format('DD/MM/YYYY')
        // }
        this.itemsDetails.push({
          field: field,
          value: value,
          result: result,
          details: request.ReturnCode
        })
      }
    },
    updateItemsDetailsPP (request) {
      this.itemsDetails = []
      for (let x = 0; x < this.fieldsDetailsControlsPP.length; x++) {
        let field = this.fieldsDetailsControlsPP[x]
        let value = request[field]
        let result = ''
        switch (field) {
          case 'IBAN': // 01xxx
            result = this.verifIban(request.ReturnCode)
            break
          case 'SIREN': // 03xxx
            result = this.verifSiren(request.ReturnCode)
            break
          case 'Type': // 02xxx
            result = this.verifType(request.ReturnCode)
            break
          case 'BirthDate': // 06xxx
            result = this.verifBirthDate(request.ReturnCode)
            break
          case 'Name': // 09xxx
            result = this.verifName(request.ReturnCode)
            break
          case 'OtherName': // 10xxx
            result = this.verifOtherName(request.ReturnCode)
            break
          default:
            break
        }
        if (field === 'BirthDate') {
          value = moment(value).format('DD/MM/YYYY')
        }
        this.itemsDetails.push({
          field: field,
          value: value,
          result: result,
          details: request.ReturnCode
        })
      }
    },
    updateItemsHisto (requests) {
      this.itemsHisto = []
      // this.idrequest = []
      for (var i = 0; i < requests.length; i++) {
        this.idrequest.push(requests[i].idrequest)
        let result = {
          name: requests[i].Name,
          Date: requests[i].Date,
          iban: requests[i].IBAN === '' ? '-' : requests[i].IBAN,
          siren: requests[i].SIREN === '' ? '-' : requests[i].SIREN,
          type: requests[i].Type === 'PP' ? 'PP' : 'PM',
          verifIban: this.verifIban(requests[i].ReturnCode) === '' ? '-' : this.verifIban(requests[i].ReturnCode),
          verifSiren: this.verifSiren(requests[i].ReturnCode) === '' ? '-' : this.verifSiren(requests[i].ReturnCode),
          StatusValidation: requests[i].StatusValidation,
          idrequest: requests[i].idrequest,
          score: this.dateScore(requests[i].ReturnCode) === '' ? '-' : this.dateScore(requests[i].ReturnCode),
          stateVerif: requests[i].Verification,
          validAll: false,
          rejectAll: false,
          paid: false,
          Login: requests[i].Login
        }
        this.itemsHisto.push(result)
      }
    },
    validate () {
      let result = []
      let action = {
        idrequest: this.idrequest[this.currentIndex],
        choice: '2'
      }
      result.push(action)
      let nbValidated = result.filter(elem => elem.choice === '2').length
      this.$engine.pain08.updateDecision(this.idfiledata, result)
      .then((resp) => {
        if (this.items[this.currentIndexList].validated === '-') {
          this.items[this.currentIndexList].validated = 0
        }
        this.items[this.currentIndexList].verif -= result.length
        this.items[this.currentIndexList].validated += nbValidated
      })
      this.showData(this.idfiledata, this.currentIndexData)
    },
    verifAll (requests, j) {
      let details = ''
      let str = requests.split(',')
      for (let i = 0; i < str.length; i++) {
        if (j === 'IBAN') {
          switch (str[i]) {
            case '01000':
              details = this.$t('pain008.false')
              break
            case '01001':
              details = this.$t('pain008.true')
              break
            case '01010':
              details = this.$t('pain008.closed_account')
              break
            case '01020':
              details = this.$t('pain008.closed_account')
              break
            case '01030':
              details = this.$t('pain008.non_existing_account')
              break
            case '01040':
              details = this.$t('pain008.account_out_of_scope')
              break
            default:
              break
          }
        } else if (j === 'SIREN') {
          switch (str[i]) {
            case '03000':
              details = this.$t('pain008.false')
              break
            case '03001':
              details = this.$t('pain008.true')
              break
            case '03020':
              details = this.$t('pain008.control_not_possible')
              break
            default:
              break
          }
        } else if (j === 'Type') {
          switch (str[i]) {
            case '02000':
              details = this.$t('pain008.false')
              break
            case '02001':
              details = this.$t('pain008.true')
              break
            default:
              break
          }
        } else if (j === 'BirthDate') {
          switch (str[i]) {
            case '06001':
              details = this.$t('pain008.true')
              break
            case '06020':
              details = this.$t('pain008.false_unable_verify_date_birth')
              break
            case '06000':
              details = this.$t('pain008.false_incorrect_date_birth')
              break
            default:
              break
          }
        }
        // if (j === 'BirthDate' && str[i] === '06020') {
        //   details = 'Faux - Impossible de vérifier la date de naissance'
        // } if (j === 'BirthDate' && str[i] === '06000') {
        //   details = 'Faux - Date de naissance incorrect'
        // }
        // } if (j === 'Type' && str[i] === '02000') {
        //   details = 'Faux - Type de titulaire incorrect'
        // } if (j === 'Name' && this.verifName(requests) > 'value acceptance') {
        //   details = 'Faux - '
        // } if (j === 'OtherName' && this.verifOtherName(requests) > 'value acceptance') {
        //   details = 'Faux - '
        // }
      }
      return details
    },
    verifBirthDate (requests) {
      let verif = ''
      let str = requests.split(',')
      for (let i = 0; i < str.length; i++) {
        if(str[i] === '06001') {
          verif = '<i class="fa-solid fa-check text-success"></i>'
        } else if (str[i] === '06000') {
          verif = '<i class="fa-solid fa-xmark text-danger"></i>'
        }
      }
      return verif
    },
    verifIban (requests) {
      let verif = ''
      let str = requests.split(',')
      for (let i = 0; i < str.length; i++) {
        if (str[i] === '01001') {
          verif = '<i class="fa-solid fa-check text-success"></i>'
        } else if (str[i] === '01000') {
          verif = '<i class="fa-solid fa-xmark text-danger"></i>'
        } else if ((str[i] === '01010') || (str[i] === '01020') || (str[i] === '01030') || (str[i] === '01040')) {
          verif = '<i class="fa-solid fa-location-exclamation"></i>'
        }
      }
      return verif
    },
    verifSiren (requests) {
      let verif = ''
      let str = requests.split(',')
      for (let i = 0; i < str.length; i++) {
        if (str[i] === '03001') {
          verif = '<i class="fa-solid fa-check text-success"></i>'
        } else if (str[i] === '03000') {
          verif = '<i class="fa-solid fa-xmark text-danger"></i>'
        } else if (str[i] === '03020') {
          verif = '<i class="fa-solid fa-location-exclamation"></i>'
        }
      }
      return verif
    },
    verifName (requests) {
      let verif = ''
      let str = requests.split(',')
      for (let i = 0; i < str.length; i++) {
        if (str[i] >= '09000' && str[i] <= '09400') {
          verif = str[i].slice(2)
        }
      }
      return verif
    },
    verifOtherName (requests) {
      let verif = ''
      let str = requests.split(',')
      for (let i = 0; i < str.length; i++) {
        if (str[i] >= '10000' && str[i] <= '10400') {
         verif = str[i].slice(2)
        }
      }
      return verif
    },
    verifStatus (request) {
      let result = ''
      if (request === '1' || request === '2') {
        result = this.$t('pain008.request_being_processed')
      } else if (request === '6') {
        result = this.$t('pain008.bank_unreachable')
      } else if (request === '10') {
        result = this.$t('pain008.positive_response')
      } else if (request === '11') {
        result = this.$t('pain008.negative_response')
      } else if (request === '12') {
        result = this.$t('pain008.expired_request')
      } else if (request === '99') {
        result = this.$t('pain008.ignored')
      }
      return result
    },
    verifType (requests) {
      let verif = ''
      let str = requests.split(',')
      for (let i = 0; i < str.length; i++) {
        if (str[i] === '02001') {
          verif = '<i class="fa-solid fa-check text-success"></i>'
        } else if (str[i] === '02000') {
          verif = '<i class="fa-solid fa-xmark text-danger"></i>'
        }
      }
      return verif
    },
    updateList (requests) {
      this.completeList = requests
    },
    showFullFileName (index) {
      this.$set(this.isMouseOver, index, true)
      //this.isMouseOver = true;
      //this.hoveredFileName = fileName;
    },
    hideFullFileName (index) {
      this.$set(this.isMouseOver, index, false)
      //this.isMouseOver = false;
    }
  }
}

</script>
